import React from 'react';
import { CameraIcon } from 'lucide-react';
interface ImagePlaceholderProps {
  label: string;
  aspectRatio?: 'square' | 'landscape' | 'portrait' | 'hero';
  className?: string;
}
export function ImagePlaceholder({
  label,
  aspectRatio = 'square',
  className = ''
}: ImagePlaceholderProps) {
  const aspectStyles = {
    square: 'aspect-square',
    landscape: 'aspect-video',
    portrait: 'aspect-[3/4]',
    hero: 'aspect-[4/3] md:aspect-[21/9]'
  };
  return <div className={`relative flex flex-col items-center justify-center w-full overflow-hidden rounded-2xl border border-[#F8C8DC] bg-gradient-to-br from-[#FFF8F0] to-[#F8C8DC] p-6 text-center shadow-sm ${aspectStyles[aspectRatio]} ${className}`} data-id="element-185">
      <CameraIcon className="w-8 h-8 md:w-12 md:h-12 text-[#E91E8C] opacity-50 mb-3" data-id="element-186" />
      <span className="font-body text-sm md:text-base font-medium text-[#6B1D4A] opacity-70 max-w-[80%]" data-id="element-187">
        {label}
      </span>
    </div>;
}